export default "__VITE_ASSET__Bg8WVsu3__"